import React, { useMemo, useEffect } from "react";
import { API } from "../../../../../api/api";
import Config from "../../../../../config";

// eslint-disable-next-line no-unused-vars
import { inc, valid } from "semver";

import moment from "moment";

import openapi from "../../../../../data/openapi";
import { parseOpenApi } from "../../../../../data/utils/openApi";

export const SAVE = "data.selection.save";
export const UPDATE = "data.selection.update";
export const UPDATE_FIELD = "data.selection.update_field";
export const UPDATE_RELATED_FIELD = "data.selection.update_related_field";
export const GENERATE = "data.selection.generate";
export const GENERATE_GLOBAL = "data.selection.generate_global";
export const INIT = "data.selection.init";
export const ENABLE_AFTER_DATE = "data.selection.enabledAfterDate";
export const AFTER_DATE = "data.selection.afterDate";
export const ENABLE_IN_STAGES = "data.selection.enableInStages";
export const RESET_TO_DEFAULT = "data.selection.reset_to_default";
export const VERSION_UPDATE = "data.selection.version_update";
export const X_API_VERSION_UPDATE = "data.selection.x_api_version_update";
export const STAGES = "data.selection.stages";
export const POLLING_INTERVALS = "data.selection.pollingIntervals";
export const ENABLE_POLLING_INTERVALS = "data.selection.enablePollingIntervals";
export const ENABLE_FULL_TABLE_RETRIEVAL = "data.selection.enableFullTableRetrieval";
export const DISABLE_BULK_RETRIEVAL = "data.selection.disableBulkRetrieval";
export const ENABLE_MANUAL_LOADING = "data.selection.manualLoading";
export const DEXIE_NAME = "data.selection.dexieName";
export const TOGGLE_ALL = "data.selection.toggleAll";
export const TOGGLE_ALL_RELATED = "data.selection.toggleAllRelated";

const DataSelectionContext = React.createContext();
const DataContext = React.createContext();

const INITIAL = {
  tables: {},
  version: "1.0.0",
};

const deleteFile = async (userId) => {
  await API.delete(
    `/deleteFile?bucketName=${Config.dataBucket}&filename=dataConfig-${userId}.json`,
    Config.baseURLAdminService,
  );
};

const generate = async (userId, updated) => {
  console.log(updated);
  // to prevent same eTag being generated for general and local dataConfig file
  updated.userId = userId;
  await API.post(
    `/saveFile?bucketName=${Config.dataBucket}&filename=dataConfig-${userId}.json`,
    Config.baseURLAdminService,
    updated,
  );
};
const generate_global = async (updated) => {
  console.log(updated);
  // should be no userId associated with general dataConfig file
  delete updated.userId;
  await API.post(
    `/saveFile?bucketName=${Config.dataBucket}&filename=dataConfig.json`,
    Config.baseURLAdminService,
    updated,
  );
};

const retrieve = async (userId) => {
  const result = await API.get(
    `/getFile?bucketName=${Config.dataBucket}&filename=dataConfig-${userId}.json`,
    Config.baseURLAdminService,
  );
  return result;
};

const retrieveGlobal = async () => {
  const result = await API.get(
    `/getFile?bucketName=${Config.dataBucket}&filename=dataConfig.json`,
    Config.baseURLAdminService,
  );
  return result;
};

const validateTable = (table) => {
  if (table.includeTable) {
    const isValid = Object.keys(table).some((key) => {
      return table[key].enabled === true;
    });
    if (!isValid) {
      table.fields.id = { enabled: true, propType: "number", queryType: "number" };
    }
  }
  return table;
};

const validateState = (state) => {
  const validated = { ...state };
  const keys = Object.keys(state.tables);
  for (let i = 0; i < keys.length; i++) {
    const table = validated.tables[keys[i]];
    validated.tables[keys[i]] = validateTable(table);
  }
  return validated;
};

const dataSelectionReducer = (state, action) => {
  const updated = { ...state };

  switch (action.type) {
    case INIT:
      delete action.payload.data.needsSaving;
      // update redux state with user or global data config and persist in preferences component state for comparison on save
      action.payload.updateSelectionPreferences(action.payload.data);
      return action.payload.data;
    case SAVE:
      delete updated.needsSaving;
      action.payload.updateSelectionPreferences(updated);
      return updated;
    case RESET_TO_DEFAULT:
      // TODO: This should delete the users dataConfig file so that the default is picked up on reload
      //       maybe even delete local data and force reload

      // delete will not work in production !!!
      // Need to check on how to do this on a s3 file from lamdba in prod.
      // Security issue at this point
      deleteFile(action.userId);
      return state;
    case GENERATE_GLOBAL: {
      // TODO: handle global save for all
      const validated = validateState(state);
      validated.version = inc(validated.version, "patch");
      delete validated.hasChanges;
      generate_global(validated);
      return validated;
    }

    case GENERATE: {
      // TODO: need to validate before saving
      //       every enabled table has to have at least one field enabled
      //       maybe force id filed to be enabled...
      const validated = validateState(state);
      validated.version = inc(validated.version, "patch");
      delete validated.hasChanges;
      validated.needsSaving = true;
      generate(action.userId, validated);
      return validated;
    }

    case UPDATE:
      console.log("UPDATE: ", action);
      if (updated.tables[action.payload.name] === undefined) {
        updated.tables[action.payload.name] = {
          includeTable: action.payload.includeTable,
          version: "1.0.0",
          fields: {},
          tableConfig: {},
        };
      } else {
        updated.tables[action.payload.name].includeTable = action.payload.includeTable;
        if (action.payload.includeTable) {
          updated.tables[action.payload.name].version = inc(
            updated.tables[action.payload.name].version || "1.0.0",
            "patch",
          );
        }
      }

      // make sure we have at least id enabled by default
      if (action.payload.includeTable) {
        updated.tables[action.payload.name].fields.id = { enabled: true, propType: "number", queryType: "number" };
      }

      break;

    case UPDATE_RELATED_FIELD:
      console.log("UPDATE_RELATED_FIELD: ", action);
      if (action.payload.value === true) {
        updated.tables[action.payload.table].fields[action.payload.parent].fields[action.payload.data.name] = {
          enabled: true,
          propType: action.payload.data.propType,
          queryType: action.payload.data.propType === "string" ? "text" : action.payload.data.propType,
        };
      } else {
        delete updated.tables[action.payload.table].fields[action.payload.parent].fields[action.payload.data.name];
      }
      updated.tables[action.payload.table].version = inc(
        updated.tables[action.payload.table].version || "1.0.0",
        "patch",
      );
      break;

    case UPDATE_FIELD:
      console.log("UPDATE_FIELD: ", action);
      if (action.payload.value === true) {
        updated.tables[action.payload.parent].fields[action.payload.data.name] = {
          enabled: true,
          propType: action.payload.data.propType,
          queryType: action.payload.data.propType === "string" ? "text" : action.payload.data.propType,
          ...(action.payload.data.format && { format: action.payload.data.format }),
        };

        // weird case of array and field type, meaning it is an string or number array
        if (action.payload.data.propType === "array" && action.payload.data.type === "field") {
          updated.tables[action.payload.parent].fields[action.payload.data.name] = {
            enabled: true,
            propType: "stringArray",
            ...(action.payload.data.format && { format: action.payload.data.format }),
          };
        } else if (action.payload.data.propType === "object" || action.payload.data.propType === "array") {
          // remove the query type as it is not needed for arrays and objects
          delete updated.tables[action.payload.parent].fields[action.payload.data.name].queryType;

          // need to set at least one field
          updated.tables[action.payload.parent].fields[action.payload.data.name].fields = {
            id: {
              enabled: true,
              propType: "number",
              queryType: "number",
            },
          };
        }
      } else {
        delete updated.tables[action.payload.parent].fields[action.payload.data.name];
      }
      updated.tables[action.payload.parent].version = inc(
        updated.tables[action.payload.parent].version || "1.0.0",
        "patch",
      );
      break;

    case ENABLE_AFTER_DATE:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.enableAfterDate = {
          enabled: action.payload.checked,
          date: moment().subtract(3, "years").format("YYYY-MM-DD"),
        };
      } else {
        delete updated.tables[action.payload.parent].tableConfig.enableAfterDate;
      }
      break;

    case AFTER_DATE:
      console.log(action.type, action);
      updated.tables[action.payload.parent].tableConfig.enableAfterDate.date = action.payload.date;
      break;

    case ENABLE_IN_STAGES:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.enableInStages = {
          enabled: action.payload.checked,
          stages: "",
        };
      } else {
        delete updated.tables[action.payload.parent].tableConfig.enableInStages;
      }
      break;
    case STAGES:
      console.log(action.type, action);
      updated.tables[action.payload.parent].tableConfig.enableInStages.stages = action.payload.value;
      break;
    case ENABLE_FULL_TABLE_RETRIEVAL:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.enableFullTableRetrieval = {
          enabled: action.payload.checked,
          intervals: "",
        };
      } else {
        delete updated.tables[action.payload.parent].tableConfig.enableFullTableRetrieval;
      }
      break;
    case ENABLE_POLLING_INTERVALS:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.enablePollingIntervals = {
          enabled: action.payload.checked,
          intervals: "",
        };
      } else {
        delete updated.tables[action.payload.parent].tableConfig.enablePollingIntervals;
      }
      break;
    case DISABLE_BULK_RETRIEVAL:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.disableBulkRetrieval = action.payload.checked;
      } else {
        delete updated.tables[action.payload.parent].tableConfig.disableBulkRetrieval;
      }
      break;
    case ENABLE_MANUAL_LOADING:
      console.log(action.type, action);
      if (action.payload.checked === true) {
        if (!updated.tables[action.payload.parent].tableConfig) {
          updated.tables[action.payload.parent].tableConfig = {};
        }
        updated.tables[action.payload.parent].tableConfig.manualLoading = action.payload.checked;
      } else {
        delete updated.tables[action.payload.parent].tableConfig.manualLoading;
      }
      break;
    case POLLING_INTERVALS:
      console.log(action.type, action);
      updated.tables[action.payload.parent].tableConfig.enablePollingIntervals.intervals = action.payload.value;
      break;

    case DEXIE_NAME:
      console.log(action.type, action);
      updated.tables[action.payload.parent].dexieName = action.payload.value;
      break;

    case VERSION_UPDATE:
      // cannot remove version
      console.log(action.type, action);
      if (action.payload.value !== "" && action.payload.value !== null) {
        updated.tables[action.payload.parent].version = action.payload.value;
      }
      break;
    case X_API_VERSION_UPDATE:
      // cannot remove version
      console.log(action.type, action);
      if (action.payload.value === "latest") {
        updated.tables[action.payload.parent].xApiVersion = "";
      } else if (action.payload.value !== "" && action.payload.value !== null) {
        updated.tables[action.payload.parent].xApiVersion = action.payload.value;
      }
      break;
    case TOGGLE_ALL:
      console.log(action.type, action);
      if (action.payload.fields && action.payload.checked) {
        action.payload.fields.forEach((field) => {
          // find the field in the current state
          updated.tables[action.payload.table].fields[field.name] = {
            enabled: true,
            propType: field.propType,
            queryType: field.propType === "string" ? "text" : field.propType,
            ...(field.format && { format: field.format }),
          };

          // weird case of array and field type, meaning it is an string or number array
          if (field.propType === "array" && field.type === "field") {
            updated.tables[action.payload.table].fields[field.name] = {
              enabled: true,
              propType: "stringArray",
              ...(field.format && { format: field.format }),
            };
          } else if (field.propType === "object" || field.propType === "array") {
            // remove the query type as it is not needed for arrays and objects
            delete updated.tables[action.payload.table].fields[field.name].queryType;

            // need to set at least one field
            updated.tables[action.payload.table].fields[field.name].fields = {
              id: {
                enabled: true,
                propType: "number",
                queryType: "number",
              },
            };
          }
        });
      } else if (action.payload.fields && action.payload.checked === false) {
        action.payload.fields.forEach((field) => {
          // find the field in the current state
          if (field.name !== "id") {
            updated.tables[action.payload.table].fields[field.name].enabled = false;
          }
        });
      }
      updated.tables[action.payload.table].version = inc(
        updated.tables[action.payload.table].version || "1.0.0",
        "patch",
      );
      break;
    case TOGGLE_ALL_RELATED:
      console.log(action.type, action);
      if (action.payload.fields && action.payload.checked) {
        if (updated.tables[action.payload.table].fields[action.payload.relatedField] === undefined) {
          updated.tables[action.payload.table].fields[action.payload.relatedField] = {
            fields: {},
          };
        }
        action.payload.fields.forEach((field) => {
          // find the field in the current state
          updated.tables[action.payload.table].fields[action.payload.relatedField].fields[field.name] = {
            enabled: true,
            propType: field.propType,
            queryType: field.propType === "string" ? "text" : field.propType,
            ...(field.format && { format: field.format }),
          };
        });
      } else {
      }
      updated.tables[action.payload.table].version = inc(
        updated.tables[action.payload.table].version || "1.0.0",
        "patch",
      );
      break;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
  updated.hasChanges = true;
  return updated;
};

const DataSelectionProvider = ({ children, userId, updateSelectionPreferences }) => {
  const [state, dispatch] = React.useReducer(dataSelectionReducer, INITIAL);

  const openApiData = useMemo(() => parseOpenApi(openapi), []);

  // initial retrival of user configured data
  useEffect(() => {
    const fetchData = async () => {
      const response = await retrieve(userId);
      return response;
    };
    const fetchGlobalData = async () => {
      const response = await retrieveGlobal();
      return response;
    };
    // fetchData returns a promise
    fetchData().then((result) => {
      // most likely a 'NoSuchKey' error, i.e. no dataConfig file exists for this user yet.
      if (result.data.error !== undefined) {
        // attempt to fetch global data config
        fetchGlobalData().then((result) => {
          if (result.data.error !== undefined) {
            dispatch({ type: INIT, payload: { updateSelectionPreferences, data: INITIAL } });
          } else {
            dispatch({ type: INIT, payload: { updateSelectionPreferences, data: result.data } });
          }
        });
      } else {
        dispatch({ type: INIT, payload: { updateSelectionPreferences, data: result.data } });
      }
    });
  }, [updateSelectionPreferences, userId]);

  const value = { state, dispatch, userId };

  useEffect(() => {
    if (state.needsSaving) {
      console.log("DataSelectionContext state updated: ", state);
      dispatch({ type: SAVE, payload: { updateSelectionPreferences } });
    }
  }, [state, state.needsSaving, updateSelectionPreferences]);

  return (
    <DataContext.Provider value={{ data: openApiData }}>
      <DataSelectionContext.Provider value={value}>{children}</DataSelectionContext.Provider>
    </DataContext.Provider>
  );
};

const useDataSelection = () => {
  const context = React.useContext(DataSelectionContext);
  if (context === undefined) {
    throw new Error("useDataSelection must be used within a DataSelectionProvider");
  }
  return context;
};

const useData = () => {
  const context = React.useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};

export { DataSelectionProvider, useDataSelection, useData };
